import { newUuidV4 } from '@taxbit-private/uuids'

import { NotificationCosmicSlice, ToastConfig } from './notificationSliceModels'
import { AppStateSlice } from '../AppStoreTypes'

const createNotificationCosmicSlice: AppStateSlice<NotificationCosmicSlice> = (set) => ({
  cosmicToasts: [],
  addCosmicToast: (toast: ToastConfig) => {
    const uuid = newUuidV4()
    set(({ cosmicToasts }) => ({
      cosmicToasts: [
        ...cosmicToasts,
        {
          uuid: uuid,
          variant: 'primary',
          timeoutMs: 5000,
          ...toast,
        },
      ],
    }))
    return uuid
  },
  removeCosmicToast: (uuidToRemove: string) =>
    set(({ cosmicToasts }) => ({
      cosmicToasts: cosmicToasts.filter(({ uuid }) => uuid !== uuidToRemove),
    })),
  clearCosmicToasts: () =>
    set(() => ({
      cosmicToasts: [],
    })),
})

export default createNotificationCosmicSlice
